<div class="layout-grid">
    <div class="info-panel"><pty-customer-basic-info [partyId]="partyId"></pty-customer-basic-info></div>
    <div class="contacts-panel"><pty-customer-contacts [partyId]="partyId"></pty-customer-contacts></div>
    <div class="payments-panel"><pty-customer-payment-info [partyId]="partyId"></pty-customer-payment-info></div>
    <div class="loyalty-panel"><pty-customer-loyalty [partyId]="partyId"></pty-customer-loyalty></div>
    <div class="identities-panel"><pty-customer-identification [partyId]="partyId"></pty-customer-identification></div>
    <div class="contents-panel"><pty-customer-content [partyId]="partyId"></pty-customer-content></div>
    <div class="notes-panel"><pty-customer-notes [partyId]="partyId"></pty-customer-notes></div>        
</div>
